module.exports = __webpack_public_path__ + "img/github.27b06ea6.svg";